<template>
  <div>
    <SHeader :icon="ICON">
      <template v-slot:title>Profile</template>
      <template v-slot:action>
        <SButton icon="fa-plus" large top right @click="dialog = true">
          Affecter
        </SButton>
      </template>
    </SHeader>

    <UserDescription v-if="user" :user="user" />

    <UserSensorsTable />

    <UserSensorsDialog
      main-icon="fa-microchip"
      v-if="dialog"
      :dialog="dialog"
      width="50%"
      :user="user"
      :old-sensors="getUserSensors"
      @closeDialog="closeDialog"
      @onErrors="openAlert"
    />

    <SAlert
      v-model="alert"
      :message="message"
      :success="successAlert"
      :error="!successAlert"
      :action-type="actionType"
      @onClose="alert = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UserDescription from "@/components/users/UserDescription";
import UserSensorsTable from "@/components/users/UserSensorsTable";
import UserSensorsDialog from "@/components/users/UserSensorsDialog";

export default {
  name: "User",
  components: {
    UserDescription,
    UserSensorsTable,
    UserSensorsDialog,
  },
  data: () => ({
    ICON: "fa-user-tie",
    dialog: false,
    alert: false,
    successAlert: false,
    message: "",
    actionType: "normal",
    user: null,
  }),
  methods: {
    ...mapActions({
      retrieveUser: "users/retrieveUser",
      retrieveUserSensors: "sensors/retrieveUserSensors",
    }),
    closeDialog() {
      this.dialog = false;
    },
    openAlert({ success, message }) {
      this.alert = true;
      this.successAlert = success;
      this.message = message;
    },
  },
  computed: {
    ...mapGetters({
      getUser: "users/getUser",
      getUsers: "users/getUsers",
      getUserSensors: "sensors/getUserSensors",
    }),
  },
  async created() {
    try {
      const userUid = this.$route.params.userId;
      if (this.getUsers.length == 0) {
        await this.retrieveUser(userUid);
        this.user = this.getUser;
      } else {
        this.user = this.getUsers.find((u) => u.uid == userUid);
      }
      await this.retrieveUserSensors(userUid);
    } catch ({ success, error }) {
      this.openAlert({ success, message: error });
    }
  },
};
</script>

<style></style>
